import apiFetch from '../apiFetch'

export default function (idCopiaSeguridad, token) {
  return apiFetch({endPoint: `CopiaSeguridad/restaurarCopiaSeguridad?idCopiaSeguridad=` + idCopiaSeguridad, method: 'GET', body: null, token: token})
}